import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import useFormContext from '../GetEvent.jsx/useFormAdminContext.js';

const ConfirmationModalRemove = ({ isOpen, onClose, onSave, onCancel, notifOptions }) => {
    const {
      modalGuest, 
      setModalGuest
    } = useFormContext();

    const [checkNotifGuest, setCheckNotifGuest] = useState(modalGuest?.status!=="Under review");
    const toggleCheckNotifGuest = () => { setCheckNotifRequestor(!checkNotifGuest); setCheckNotifGuest((prevCheckNotifGuest) => !prevCheckNotifGuest); };
    const [checkNotifRequestor, setCheckNotifRequestor] = useState(modalGuest?.status!=="Under review");
    const toggleCheckNotifRequestor = () => { setCheckNotifRequestor((prevCheckNotifRequestor) => !prevCheckNotifRequestor); };
 
    const handleSave = () => {
      onSave((notifOptions==="true") ? checkNotifGuest : true,(notifOptions==="true") ? checkNotifRequestor : true);  
    };
 
    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle' style={{ userSelect: 'none'}}>Remove guest</h5>
                <p className='popup-text' style={{ userSelect: 'none'}}>Are you sure you want to remove this guest from the event?</p>
                <p className='popup-text' style={{ userSelect: 'none'}}>There will be no notifications, if you want the guest and/or requestor to be notified, please decline instead of deleting.</p>
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button className="btn btn-cancel" onClick={onCancel}>CANCEL</button>
                    <button className="btn btn-save" onClick={handleSave}>SAVE</button>
                </div>
            </div>
        </Popup>
    );
};
 
export default ConfirmationModalRemove;